module.exports = __webpack_public_path__ + "img/down-menu-mobile.a8c4c96.svg";